'use client';
import React, { ChangeEvent } from 'react';

import classNames from 'classnames';
import currency from 'currency.js';
import { useTranslation } from 'react-i18next';

import { NamespacesI18n } from '@storefront/i18n';

import styles from './selection-button.module.scss';

import { renderPrice } from './selection-button-util';

export interface SelectionButtonOptionalProps {
  uid: string;
  isDisabled?: boolean;
  selectedPaperOption?: boolean;
  name: string;
  onChange?: (event: ChangeEvent<HTMLInputElement>) => void;
  checked: boolean;
  price?: number | currency;
  onRemove?: () => void;
}

export const SelectionButtonOptional = ({
  uid,
  onChange,
  name,
  checked,
  isDisabled,
  selectedPaperOption,
  onRemove,
  price,
}: SelectionButtonOptionalProps) => {
  const { t } = useTranslation(NamespacesI18n.PDP_CONFIG);

  const renderButton = (action: string) => (
    <div
      className={styles['label-container']}
      data-testid="label-container-test"
    >
      <div className={styles['label-container-wrapper']}>
        <div className={styles['description-container-no-image']}>
          <div
            className={classNames(styles['text-container'], styles['optional'])}
            data-testid="text-container-test"
          >
            <div className={styles['title-row-content-yes-or-no']}>
              <div className={classNames(styles['title'], 'body-extra-large')}>
                {t(`pdpConfig.optional.${action}`)}
              </div>
              {action === 'add' && renderPrice(checked, price || 0)}
            </div>
          </div>
        </div>
      </div>
    </div>
  );

  return (
    <>
      <div className={styles['button-container']}>
        <label
          className={`button-label`}
          data-testid="button-label-test"
          aria-label={name}
        >
          <input
            id={name}
            onChange={onChange}
            data-testid={uid}
            disabled={isDisabled}
            className={
              isDisabled ? styles['button-disabled'] : styles['button']
            }
            type="radio"
            name={name}
            value={uid}
            checked={!isDisabled && checked}
            tabIndex={0}
          />
          {renderButton('add')}
        </label>
      </div>
      <div className={styles['button-container']}>
        <label
          className={`button-label`}
          data-testid="button-label-test"
          aria-label={name}
        >
          <input
            id={`${name}-remove`}
            data-testid={`${uid}-remove`}
            disabled={isDisabled}
            className={
              isDisabled ? styles['button-disabled'] : styles['button']
            }
            type="radio"
            name={name}
            onChange={onRemove}
            value={uid}
            checked={!isDisabled && !checked && selectedPaperOption}
            tabIndex={0}
          />
          {renderButton('remove')}
        </label>
      </div>
    </>
  );
};
